import { schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { fetch } from '../fetch';

export const cancelAnalysis = async (analysisId: number): Promise<void> => {
  await fetch(
    `/analysis/${analysisId}/cancel`,
    { method: 'post' },
    schemas.SuccessDto
  );
};

export function useCancelAnalysisMutation() {
  const mutation = useMutation({
    mutationKey: ['cancelAnalysis'],
    mutationFn: async (args: { analysisId: number }) => {
      return cancelAnalysis(args.analysisId);
    },
    retry: false
  });

  return mutation;
}
